export default [
  {
		"name": "item A",
		"category": "Uncategorized",
		"description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries",
		"published" :true,
		"serial": true,
		"campaignId": 100,
  },
  {
		"name": "item B",
		"category": "Uncategorized",
		"published" : false,
		"serial": false,
		"campaignId": 101
  },
  {
		"name": "item C",
		"category": "Uncategorized",
		"published" :true,
		"serial": true,
		"campaignId": 102
  },
  {
		"name": "item D",
		"category": "Uncategorized",
		"published" :true,
		"serial": false,
		"campaignId": 103
  },

	{
		"name": "foo A",
		"category": "Uncategorized",
		"published" :true,
		"serial": false,
		"campaignId": 104
	},
	
  {
		"name": "foo B",
		"category": "Uncategorized",
		"published" :true,
		"serial": false,
		"campaignId": 105
  },
  {
		"name": "foo C",
		"category": "Uncategorized",
		"published" :true,
		"serial": false,
		"campaignId": 106
  },
  {
		"name": "foo D",
		"category": "Uncategorized",
		"published" :true,
		"serial": false,
		"campaignId": 107
  },
	
	{
		"name": "product A",
		"category": "Uncategorized",
		"published" :true,
		"serial": false,
		"campaignId": 108
	},
	
  {
		"name": "product B",
		"category": "Uncategorized",
		"published" :true,
		"serial": false,
		"campaignId": 109
  },
  {
		"name": "product C",
		"category": "Uncategorized",
		"published" :true,
		"serial": false,
		"campaignId": 111
  },
  {
		"name": "product D",
		"category": "Uncategorized",
		"published" :true,
		"serial": false,
		"campaignId": 112
  },

];